<template>
  <pa-header></pa-header>
  <div class="text-center flex items-center justify-center py-40" v-if="loading">
    <div class="lds-ripple">
      <div></div>
    </div>
    Loading please wait...
  </div>
  <div class="container-fluid">
    <div class="row">
      <div v-for="(channel,index) in channels" v-bind:key="index" class="col-sm-2">
        <a v-bind:tabindex="5+index" @click="openVideo(channel)" @keyup.enter='openVideo(channel)'
           class="video block py-8 video mb-4 d-block  rounded-2xl">
          <img v-bind:src="'images/'+channel.flag+'.svg'" alt=""
               style="width: 150px;height: 80px;display: block ;  margin: auto; margin-bottom: 20px">
          <span class="font-oswald text-3xl uppercase">{{ channel.name }}</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import PaHeader from "@/views/Pa-Header";

var SpatialNavigation = window.SpatialNavigation;
export default {
  components: {PaHeader},
  data() {
    return {
      channels: [],
      loading: false,
    }
  },
  methods: {
    openVideo(v) {
      var to = {
        name: "pa-stream", //use name for router push
        params: {id: v.link}
      };

      this.$router.push(to);
    }
  },
  mounted() {
    var el = document.querySelectorAll('.router-link-exact-active')[0];
    if (el) el.classList.add('active');
    SpatialNavigation.focus('.router-link-exact-active');
    this.$data.loading = true;
    axios
        .get('http://api.patv.in/prime-asia-tv/channels.php')
        .then(res => {
          this.$data.channels = [...res.data.video_streams];
          setTimeout(() => {
            SpatialNavigation.makeFocusable();
            SpatialNavigation.focus();
          }, 200)

        })
        .catch(() => {
          this.$data.channels = [{name: 'Prime Asia Tv', link: 'http://primeasia.dyndns.tv/Live_720p_Web/index.m3u8'}];
        }).finally(() => {
      this.$data.loading = false;
    })
  }
}
</script>
<style lang="scss">

</style>
